export const WHITE = '#fff';
export const BLACK = '#3C4852';
export const DISABLED = '#F0F4F7';
export const RED = '#FF0000';
export const GREEN = '#08BD80';
export const FILLED = '#3C4852';
export const LIVE = '#EB5757';
export const GREY = '#DDE6ED';
export const OFF_WHITE = '#f7f7f7';
export const LIGHT_GREEN = '#E6F8F2';
export const LIGHTER_GREEN = '#EDFDF8';
export const DARK_GREEN = '#07a872';
export const DARK_RED = '#d64f4f';
export const LIGHT_BLACK = '#636D75';
export const BASE = '#fcfcfc';
export const LIGHT_GREY = '#E5E5E5';
export const DARK_GREY = '#8FA3B2';
export const BLUE = '#2D81F7';
export const LIGHT_BLUE = '#FAFBFC';
export const ORANGE = '#FFAD3B';
export const MUSTARD = '#FFF8ED';
export const LIGHT_MUSTARD = '#FFF9EF';
export const LIGHT_ORANGE = '#FFEBCE';
export const LIGHTER_ORANGE = '#FBF6E7';
export const DARK_ORANGE = '#FFE2BA';
export const LIGHTER_BLUE = '#E5EDFA';
export const LIGHT_RED = '#FFDAE1';
export const LIGHTER_RED = '#FFF6F6';
export const SEA_GREEN = '#15B4BB';
export const DARKER_GREY = '#9AAFBF';
export const dropShadow = 'rgb(0,0,0,.1)';
export const DULL_TURQUOISE = '#21C5C6';
export const VIOLET = '#BA61D4';
export const VANILLA = '#F08FB4';
